module.exports = __webpack_public_path__ + "static/media/emi.4925830f.png";